{
  "pages": [
    {
      "name": "Buffer Tank",
      "elements": [
        {
          "type": "panel",
          "name": "Buffer Tank",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "boolean",
              "name": "Control_enabled",
              "title": "Control of buffer tank enabled?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "Setpoint",
              "visibleIf": "{Control_enabled} = true",
              "title": "Setpoint for the buffer tank",
              "validators": [
                {
                  "type": "numeric",
                  "minValue": 0,
                  "maxValue": 100
                }
              ],
              "inputType": "number",
              "placeHolder": "Setpoint for the buffer tank"
            }
          ],
          "title": "Buffer tank info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "Tank Sensors",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_START",
              "visibleIf": "{Control_enabled} = true and ( {T_STOP} == \"CENTERTOP\"  )",
              "title": "Temperature sensor used to start charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "TOP",
                  "text": "Top sensor"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "T_START",
              "visibleIf": "{Control_enabled} = true and ({T_STOP} == \"CENTERBOTTOM\" )",
              "title": "Temperature sensor used to start charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "TOP",
                  "text": "Top sensor"
                },
                {
                  "value": "CENTERTOP",
                  "text": "Centertop sensor"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "T_START",
              "visibleIf": "{Control_enabled} = true and ({T_STOP} != \"TOP\" and {T_STOP} != \"CENTERTOP\" and {T_STOP} != \"CENTERBOTTOM\"  )",
              "title": "Temperature sensor used to start charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "TOP",
                  "text": "Top sensor"
                },
                {
                  "value": "CENTERTOP",
                  "text": "Centertop sensor"
                },
                {
                  "value": "CENTERBOTTOM",
                  "text": "Centerbottom sensor"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "T_STOP",
              "visibleIf": "{Control_enabled} = true and ({T_START} != \"CENTERTOP\" and {T_START} != \"CENTERBOTTOM\" and {T_START} != \"BOTTOM\" )",
              "title": "Temperature sensor used to stop charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "CENTERTOP",
                  "text": "Center top sensor"
                },
                {
                  "value": "CENTERBOTTOM",
                  "text": "Center bottom sensor"
                },
                {
                  "value": "BOTTOM",
                  "text": "Bottom sensor"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "T_STOP",
              "visibleIf": "{Control_enabled} = true and ({T_START} == \"CENTERTOP\" )",
              "title": "Temperature sensor used to stop charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "CENTERBOTTOM",
                  "text": "Center bottom sensor"
                },
                {
                  "value": "BOTTOM",
                  "text": "Bottom sensor"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "T_STOP",
              "visibleIf": "{Control_enabled} = true and ({T_START} == \"CENTERBOTTOM\" )",
              "title": "Temperature sensor used to stop charging the buffertank",
              "isRequired": true,
              "choices": [
                {
                  "value": "BOTTOM",
                  "text": "Bottom sensor"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "T_T_present",
              "title": "Tank top temperature",
              "visibleIf": "{T_START} != \"TOP\"",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_CENTERTOP_present",
              "title": "Tank center top temperature",
              "visibleIf": "({T_START} != \"CENTERTOP\") and ({T_STOP} != \"CENTERTOP\") ",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_CENTERBOTTOM_present",
              "title": "Tank center bottom temperature",
              "visibleIf": "({T_START} != \"CENTERBOTTOM\") and ({T_STOP} != \"CENTERBOTTOM\") ",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_BOTTOM_present",
              "title": "Tank bottom temperature",
              "visibleIf": "({T_STOP} != \"BOTTOM\") ",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Tank Temperature Sensors"
        },
        {
          "type": "panel",
          "name": "Sensors",
          "elements": [
            {
              "type": "boolean",
              "name": "T_SF_present",
              "title": "Secondary side forward temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SR_present",
              "title": "Secondary side return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PF_present",
              "title": "Primary side supply temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PR_present",
              "title": "Primary side return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Temperature Sensors"
        },
        {
          "type": "panel",
          "name": "panel222",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_SF_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_SF_present} == true",
          "title": "Secondary side forward temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel4",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_SR_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_SR_present} == true",
          "title": "Secondary return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel5",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PF_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PF_present} == true",
          "title": "Primary side supply temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel11",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PR_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PR_present} == true",
          "title": "Primary side return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_T_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "(T_T_present == true) or ({T_STOP} == \"TOP\") or ({T_START} == \"TOP\" )",
          "title": "Tank top temperature sensor details"
        },
        {
          "type": "panel",
          "name": "T_CENTERTOP-details",
          "title": "Tank center top sensor details",
          "visibleIf": "(T_CENTERTOP_present == true) or ({T_STOP} == \"CENTERTOP\") or ({T_START} == \"CENTERTOP\" )",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_CENTERTOP_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "T_CENTERBOTTOM-details",
          "title": "Tank center bottom sensor details",
          "visibleIf": "(T_CENTERBOTTOM_present == true) or ({T_STOP} == \"CENTERBOTTOM\") or ({T_START} == \"CENTERBOTTOM\" )",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_CENTERBOTTOM_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "T_BOTTOM-details",
          "title": "Tank bottom sensor details",
          "visibleIf": "(T_BOTTOM_present == true) or ({T_STOP} == \"BOTTOM\") or ({T_START} == \"BOTTOM\" )",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_BOTTOM_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}